import { TPhoneTag } from 'api/phoneCases/phoneCases.types';
import { TProductFilters } from 'api/types';
import {
  TProductsFiltersDrawerBlock,
  EProductsFiltersDrawerBlockType,
  TRangeSliderFiltersProps,
} from 'components';

export const calculateDiscountPercentage = (
  price: number,
  newPrice: number
) => {
  const discount = ((price - newPrice) / price) * 100;

  // Clamp the result between 1 and 100
  return Math.min(Math.max(Math.round(discount), 1), 100);
};

export const getSelectedProductFiltersCount = (
  selectedFilters: TProductFilters,
  filters: TProductsFiltersDrawerBlock[]
): number => {
  const cleanedFilters = Object.entries(selectedFilters).filter(
    ([key, value]) => {
      // Skip empty arrays
      if (Array.isArray(value) && value.length === 0) {
        return false;
      }

      // Skip empty objects
      if (
        typeof value === 'object' &&
        value !== null &&
        !Array.isArray(value) &&
        Object.keys(value).length === 0
      ) {
        return false;
      }

      // Find the corresponding filter definition
      const filterDef = filters.find((filter) => filter.id === key);

      // If it's a RangeSlider filter, check if value equals min/max
      if (
        filterDef?.blockType === EProductsFiltersDrawerBlockType.RangeSlider
      ) {
        const rangeProps = filterDef.blockProps as TRangeSliderFiltersProps;

        // Check if value is a number array (range slider value)
        if (Array.isArray(value) && value.length === 2) {
          const [first, last] = value as number[];
          // If first item equals minPrice and last item equals maxPrice, it's not selected
          if (first === rangeProps.minPrice && last === rangeProps.maxPrice) {
            return false;
          }
        }
      }

      // Keep all other values
      return true;
    }
  );

  return cleanedFilters.length;
};

export const tagListToFilterOptions = (tagsList: TPhoneTag[]) => {
  return {
    id: 'tags',
    blockTitle: 'Теги',
    blockType: EProductsFiltersDrawerBlockType.CheckboxGroup,
    blockProps: {
      options: tagsList.map((tag) => ({
        id: tag.id,
        label: tag.name,
      })),
    },
    initialValue: [],
  };
};
